export const SPORTS_EQUIPMENT_SUBMIT = "booking/SPORTS_EQUIPMENT_SUBMIT"
export const SPORTS_EQUIPMENT_SUBMIT_FAILURE = "booking/SPORTS_EQUIPMENT_SUBMIT_FAILURE"

export default SPORTS_EQUIPMENT_SUBMIT
